import { defineStore } from 'pinia';
import { commonService } from '~/services/common.service';
import { handleCommonActions } from '~/utils/store.util';

export const useCommonStore = defineStore('common', {
    state: () => ({
        brands: [],
        categories: [],
        subCategories: []
    }),
    actions: {
        async fetchBrands() {
            return await handleCommonActions(async () => {
                const response = await commonService.getAllBrands();
                this.brands = response.data?.data?.filter(brand => brand.name !== null) ?? [];
            });
        },
        async fetchCategories() {
            return await handleCommonActions(async () => {
                const response = await commonService.getAllCategories();
                this.categories = response?.data?.filter(category => category.name !== null) ?? [];
            });
        },
        async fetchSubCategoriesByCategory(id) {
            this.subCategories = [];
            return await handleCommonActions(async () => {
                const response = await commonService.getAllSubCategoriesByCategory(id);
                this.subCategories = response.data?.data?.filter(category => category.name !== null) ?? [];
            });
        },
    },
});
